// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wai-section {
  margin-bottom: 1rem;
}

/* The resize handle takes the place of the section's bottom margin. */
.wai-section--resizable {
  margin-bottom: 0;
}

.wai-resize-handle {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 1rem;
  cursor: row-resize;
  touch-action: none;
  outline: none;
}

.wai-resize-handle__grip {
  width: 2.25rem;
  height: 4px;
  border-radius: 999px;
  background: rgba(148, 163, 184, 0.45);
  transition: background 0.15s ease, width 0.15s ease;
}

.wai-resize-handle:hover .wai-resize-handle__grip,
.wai-resize-handle:focus-visible .wai-resize-handle__grip,
.wai-resizing .wai-resize-handle__grip {
  width: 3rem;
  background: rgba(100, 116, 139, 0.8);
}

.dark .wai-resize-handle:hover .wai-resize-handle__grip,
.dark .wai-resize-handle:focus-visible .wai-resize-handle__grip,
.dark .wai-resizing .wai-resize-handle__grip {
  background: rgba(203, 213, 225, 0.75);
}

.wai-resize-handle:focus-visible .wai-resize-handle__grip {
  outline: 2px solid rgba(59, 130, 246, 0.55);
  outline-offset: 2px;
}

body.wai-resizing {
  cursor: row-resize;
  -webkit-user-select: none;
          user-select: none;
}

.wai-panel__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.65rem;
}

.wai-panel__title-row {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  min-width: 0;
}

.wai-panel__header-right {
  display: flex;
  align-items: center;
  gap: 0.55rem;
}

.wai-panel__title {
  margin: 0;
  font-size: 0.92rem;
  font-weight: 700;
  color: #0f172a;
}

.wai-panel__title-short {
  display: none;
}

.dark .wai-panel__title {
  color: #f8fafc;
}

@media (max-width: 1574px) {
  .wai-panel__title-full {
    display: none;
  }

  .wai-panel__title-short {
    display: inline;
  }
}

.wai-panel__info-btn {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1.5px solid #9ca3af;
  color: #9ca3af;
  font-size: 0.75rem;
  font-weight: 600;
  font-style: italic;
  background: transparent;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  padding: 0;
}

.wai-panel__info-btn:hover {
  border-color: #6b7280;
  color: #6b7280;
  transform: scale(1.1);
}

.dark .wai-panel__info-btn {
  border-color: #6b7280;
  color: #6b7280;
}

.dark .wai-panel__info-btn:hover {
  border-color: #9ca3af;
  color: #9ca3af;
}

.wai-panel__latest {
  display: flex;
  align-items: baseline;
  gap: 0.35rem;
  margin-right: 0.15rem;
}

.wai-panel__latest-label {
  font-size: 0.74rem;
  color: #64748b;
}

.wai-panel__latest-value {
  font-size: 1rem;
  color: #0f172a;
}

.dark .wai-panel__latest-label {
  color: #94a3b8;
}

.dark .wai-panel__latest-value {
  color: #f8fafc;
}

.wai-panel__toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #64748b;
  cursor: pointer;
  transition: color 0.15s ease, transform 0.15s ease;
}

.wai-panel__toggle:hover {
  color: #334155;
}

.dark .wai-panel__toggle {
  color: #94a3b8;
}

.dark .wai-panel__toggle:hover {
  color: #e2e8f0;
}

.wai-header-divider {
  border-top: 1px dashed #cbd5e1;
  margin-bottom: 0.65rem;
}

.dark .wai-header-divider {
  border-top-color: #475569;
}

.wai-empty-state {
  min-height: 168px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 0.84rem;
  color: #64748b;
  border-top: 1px dashed #cbd5e1;
  padding-top: 1rem;
}

.dark .wai-empty-state {
  color: #94a3b8;
  border-color: #475569;
}

.wai-chart {
  padding-top: 0.1rem;
}

.wai-chart__svg {
  width: 100%;
  height: auto;
  display: block;
}

.wai-chart__grid line {
  stroke: rgba(148, 163, 184, 0.42);
  stroke-width: 1;
}

.wai-chart__grid text,
.wai-chart__axis-label {
  fill: #64748b;
  font-size: 10px;
}

.dark .wai-chart__grid text,
.dark .wai-chart__axis-label {
  fill: #94a3b8;
}

.wai-chart__axis {
  stroke: rgba(100, 116, 139, 0.55);
  stroke-width: 1.1;
}

.dark .wai-chart__axis {
  stroke: rgba(148, 163, 184, 0.72);
}

.wai-chart__line {
  fill: none;
  stroke: #2563eb;
  stroke-width: 2.2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.wai-chart__line--future {
  stroke: rgba(37, 99, 235, 0.38);
  stroke-dasharray: 5 5;
}

.dark .wai-chart__line {
  stroke: #34d399;
}

.dark .wai-chart__line--future {
  stroke: rgba(52, 211, 153, 0.42);
}

.wai-chart__point {
  fill: #2563eb;
}

.wai-chart__point-group--future .wai-chart__point {
  fill: rgba(37, 99, 235, 0.38);
}

.dark .wai-chart__point {
  fill: #34d399;
}

.dark .wai-chart__point-group--future .wai-chart__point {
  fill: rgba(52, 211, 153, 0.42);
}

.wai-chart__hit-area {
  fill: transparent;
}

.wai-chart__point-group {
  cursor: pointer;
}

.wai-chart__point--hovered {
  stroke: rgba(37, 99, 235, 0.28);
  stroke-width: 3;
}

.dark .wai-chart__point--hovered {
  stroke: rgba(52, 211, 153, 0.35);
}

.wai-chart__tooltip-label {
  fill: #0f172a;
  font-size: 14px;
  font-weight: 700;
  paint-order: stroke;
  stroke: rgba(255, 255, 255, 0.85);
  stroke-width: 3;
  stroke-linejoin: round;
}

.dark .wai-chart__tooltip-label {
  fill: #f8fafc;
  stroke: rgba(15, 23, 42, 0.85);
}
`, "",{"version":3,"sources":["webpack://./src/components/report/WorkingAllianceChart.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA,sEAAsE;AACtE;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,oBAAoB;EACpB,qCAAqC;EACrC,mDAAmD;AACrD;;AAEA;;;EAGE,WAAW;EACX,oCAAoC;AACtC;;AAEA;;;EAGE,qCAAqC;AACvC;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;EACjC,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC","sourcesContent":[".wai-section {\n  margin-bottom: 1rem;\n}\n\n/* The resize handle takes the place of the section's bottom margin. */\n.wai-section--resizable {\n  margin-bottom: 0;\n}\n\n.wai-resize-handle {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 1rem;\n  cursor: row-resize;\n  touch-action: none;\n  outline: none;\n}\n\n.wai-resize-handle__grip {\n  width: 2.25rem;\n  height: 4px;\n  border-radius: 999px;\n  background: rgba(148, 163, 184, 0.45);\n  transition: background 0.15s ease, width 0.15s ease;\n}\n\n.wai-resize-handle:hover .wai-resize-handle__grip,\n.wai-resize-handle:focus-visible .wai-resize-handle__grip,\n.wai-resizing .wai-resize-handle__grip {\n  width: 3rem;\n  background: rgba(100, 116, 139, 0.8);\n}\n\n.dark .wai-resize-handle:hover .wai-resize-handle__grip,\n.dark .wai-resize-handle:focus-visible .wai-resize-handle__grip,\n.dark .wai-resizing .wai-resize-handle__grip {\n  background: rgba(203, 213, 225, 0.75);\n}\n\n.wai-resize-handle:focus-visible .wai-resize-handle__grip {\n  outline: 2px solid rgba(59, 130, 246, 0.55);\n  outline-offset: 2px;\n}\n\nbody.wai-resizing {\n  cursor: row-resize;\n  user-select: none;\n}\n\n.wai-panel__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-bottom: 0.65rem;\n}\n\n.wai-panel__title-row {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  min-width: 0;\n}\n\n.wai-panel__header-right {\n  display: flex;\n  align-items: center;\n  gap: 0.55rem;\n}\n\n.wai-panel__title {\n  margin: 0;\n  font-size: 0.92rem;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.wai-panel__title-short {\n  display: none;\n}\n\n.dark .wai-panel__title {\n  color: #f8fafc;\n}\n\n@media (max-width: 1574px) {\n  .wai-panel__title-full {\n    display: none;\n  }\n\n  .wai-panel__title-short {\n    display: inline;\n  }\n}\n\n.wai-panel__info-btn {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  border: 1.5px solid #9ca3af;\n  color: #9ca3af;\n  font-size: 0.75rem;\n  font-weight: 600;\n  font-style: italic;\n  background: transparent;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  padding: 0;\n}\n\n.wai-panel__info-btn:hover {\n  border-color: #6b7280;\n  color: #6b7280;\n  transform: scale(1.1);\n}\n\n.dark .wai-panel__info-btn {\n  border-color: #6b7280;\n  color: #6b7280;\n}\n\n.dark .wai-panel__info-btn:hover {\n  border-color: #9ca3af;\n  color: #9ca3af;\n}\n\n.wai-panel__latest {\n  display: flex;\n  align-items: baseline;\n  gap: 0.35rem;\n  margin-right: 0.15rem;\n}\n\n.wai-panel__latest-label {\n  font-size: 0.74rem;\n  color: #64748b;\n}\n\n.wai-panel__latest-value {\n  font-size: 1rem;\n  color: #0f172a;\n}\n\n.dark .wai-panel__latest-label {\n  color: #94a3b8;\n}\n\n.dark .wai-panel__latest-value {\n  color: #f8fafc;\n}\n\n.wai-panel__toggle {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: #64748b;\n  cursor: pointer;\n  transition: color 0.15s ease, transform 0.15s ease;\n}\n\n.wai-panel__toggle:hover {\n  color: #334155;\n}\n\n.dark .wai-panel__toggle {\n  color: #94a3b8;\n}\n\n.dark .wai-panel__toggle:hover {\n  color: #e2e8f0;\n}\n\n.wai-header-divider {\n  border-top: 1px dashed #cbd5e1;\n  margin-bottom: 0.65rem;\n}\n\n.dark .wai-header-divider {\n  border-top-color: #475569;\n}\n\n.wai-empty-state {\n  min-height: 168px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  font-size: 0.84rem;\n  color: #64748b;\n  border-top: 1px dashed #cbd5e1;\n  padding-top: 1rem;\n}\n\n.dark .wai-empty-state {\n  color: #94a3b8;\n  border-color: #475569;\n}\n\n.wai-chart {\n  padding-top: 0.1rem;\n}\n\n.wai-chart__svg {\n  width: 100%;\n  height: auto;\n  display: block;\n}\n\n.wai-chart__grid line {\n  stroke: rgba(148, 163, 184, 0.42);\n  stroke-width: 1;\n}\n\n.wai-chart__grid text,\n.wai-chart__axis-label {\n  fill: #64748b;\n  font-size: 10px;\n}\n\n.dark .wai-chart__grid text,\n.dark .wai-chart__axis-label {\n  fill: #94a3b8;\n}\n\n.wai-chart__axis {\n  stroke: rgba(100, 116, 139, 0.55);\n  stroke-width: 1.1;\n}\n\n.dark .wai-chart__axis {\n  stroke: rgba(148, 163, 184, 0.72);\n}\n\n.wai-chart__line {\n  fill: none;\n  stroke: #2563eb;\n  stroke-width: 2.2;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.wai-chart__line--future {\n  stroke: rgba(37, 99, 235, 0.38);\n  stroke-dasharray: 5 5;\n}\n\n.dark .wai-chart__line {\n  stroke: #34d399;\n}\n\n.dark .wai-chart__line--future {\n  stroke: rgba(52, 211, 153, 0.42);\n}\n\n.wai-chart__point {\n  fill: #2563eb;\n}\n\n.wai-chart__point-group--future .wai-chart__point {\n  fill: rgba(37, 99, 235, 0.38);\n}\n\n.dark .wai-chart__point {\n  fill: #34d399;\n}\n\n.dark .wai-chart__point-group--future .wai-chart__point {\n  fill: rgba(52, 211, 153, 0.42);\n}\n\n.wai-chart__hit-area {\n  fill: transparent;\n}\n\n.wai-chart__point-group {\n  cursor: pointer;\n}\n\n.wai-chart__point--hovered {\n  stroke: rgba(37, 99, 235, 0.28);\n  stroke-width: 3;\n}\n\n.dark .wai-chart__point--hovered {\n  stroke: rgba(52, 211, 153, 0.35);\n}\n\n.wai-chart__tooltip-label {\n  fill: #0f172a;\n  font-size: 14px;\n  font-weight: 700;\n  paint-order: stroke;\n  stroke: rgba(255, 255, 255, 0.85);\n  stroke-width: 3;\n  stroke-linejoin: round;\n}\n\n.dark .wai-chart__tooltip-label {\n  fill: #f8fafc;\n  stroke: rgba(15, 23, 42, 0.85);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
